module.exports = __webpack_public_path__ + "media/images/flags/32/Vanuatu-7d2680d57fc0c4f5aa1893193fdf8209.png";